import React, { useState } from 'react'
import SkeletonDivElement from '../../component/skeletonTableRow/skeletonDivElement';
import logo from "../../icons/photos/chillLogo.png"
import adScreenOneImg1 from "../../media/images/adAssets/adScreenOneImg1.png"
import adScreenOneImg2 from "../../media/images/adAssets/adScreenOneImg2.png"
import adScreenOneImg3 from "../../media/images/adAssets/adScreenOneImg3.png"
import adScreenOneImg4 from "../../media/images/adAssets/adScreenOneImg4.png"
import adScreenTwoImg1 from "../../media/images/adAssets/adScreenTwoImg1.png"
import adScreenTwoImg2 from "../../media/images/adAssets/adScreenTwoImg2.png"
import adScreenTwoImg3 from "../../media/images/adAssets/adScreenTwoImg3.png"
import adScreenTwoImg4 from "../../media/images/adAssets/adScreenTwoImg4.png"
import scanDeviceVid from "../../media/videos/scanDeviceVid.mp4"
import PrimaryButton from '../../jsx/components/button/primaryButton';
import { useNavigate } from 'react-router-dom';

const AdLinkA = () => {
    const navigate = useNavigate();
    const [adSteps, setAdSteps] = useState(1);
    const [adLinkObj, setAdLinkObj] = useState({});
    const [adLinkSolutionObj, setAdLinkSolutionObj] = useState({});
    const adScreenOneArr = [
        {
            id: 1,
            title: 'A dripping faucet',
            img: adScreenOneImg1,
        },
        {
            id: 2,
            title: 'Heating or cooling',
            img: adScreenOneImg2
        },
        {
            id: 3,
            title: 'A running toilet',
            img: adScreenOneImg3
        },
        {
            id: 4,
            title: 'Something else',
            img: adScreenOneImg4
        },
    ]

    const adScreenTwoArr = [
        {
            id: 1,
            title: 'I’m worried about the cost',
            img: adScreenTwoImg1,
        },
        {
            id: 2,
            title: 'It seems complicated',
            img: adScreenTwoImg2
        },
        {
            id: 3,
            title: 'I haven’t had time',
            img: adScreenTwoImg3
        },
        {
            id: 4,
            title: 'I don’t know where to start',
            img: adScreenTwoImg4
        },
    ]

    const handleBack = () => {
        setAdSteps(adSteps - 1);
        if (adSteps === 2) setAdLinkSolutionObj({});
    }

    return (
        <>
            <div className="row m-3 mx-4">
                {window.innerWidth > 768 && <div className='col-md-3'></div>}
                <div className='col-md-6 col-12'>

                    <div className='row mx-0 mb-5'>
                        <div className='col-12 px-0 d-flex align-items-center'>
                            {adSteps > 1 &&
                                <span
                                    className='cursor-pointer p-2 rounded-3 overlay-action-btn me-2'
                                    onClick={() => {
                                        handleBack();
                                    }}
                                    style={{ fontSize: '20px', }}
                                >
                                    <i class="bi bi-arrow-left"></i>
                                </span>
                            }
                            <img src={logo} style={{ width: '100px', }} alt="" />
                        </div>
                    </div>

                    {adSteps === 1 ?
                        <>
                            <div className='row mx-0 mb-3'>
                                <div className='col-12'>

                                    <div className='mb-4'>
                                        <div className='mb-2'>
                                            <span className='font-w600'>
                                                {`LET'S START HERE`}
                                            </span>
                                        </div>

                                        <div className='mb-2'>
                                            <span className="font-w600 text-black fs-1">
                                                {`What's going on at home?`}
                                            </span>
                                        </div>

                                        <div className='mb-2'>
                                            <span className='fs-5'>
                                                {`You don't need to know the cause.`}
                                            </span>
                                        </div>
                                    </div>

                                    <div className='mb-5'>
                                        {adScreenOneArr?.map((item, index) => {
                                            return (
                                                <div
                                                    key={index}
                                                    className='mb-2 d-flex align-items-center justify-content-between cursor-pointer p-2 rounded-3 overlay-action-btn'
                                                    style={{
                                                        backgroundColor: adLinkObj?.id === item?.id ? 'rgb(255 165 0 / 18%)' : '',
                                                    }}
                                                    onClick={() => {
                                                        setAdSteps(2);
                                                        setAdLinkObj(item);
                                                    }}
                                                >
                                                    <div className='me-2 d-flex justify-content-center align-items-center'>
                                                        <div className='me-3'>
                                                            <img src={item?.img} style={{ width: '50px', height: '50px' }} alt="" />
                                                        </div>
                                                        <div>
                                                            <span className=" text-black fs-4">
                                                                {item?.title}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div>
                                                        <i class="bi bi-chevron-right fs-3 text-black"></i>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>

                                    <div className='mb-2 d-flex align-items-center justify-content-center'>
                                        <span className='text-black d-flex align-items-center justify-content-center text-center fs-5'>
                                            {`A clearer next step starts here.`}
                                        </span>
                                    </div>

                                    <div className='mb-2 d-flex align-items-center justify-content-center'>
                                        <span className='d-flex align-items-center justify-content-center text-center'>
                                            {`Free estimate. No account. No app.`}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </> :
                        adSteps === 2 ?
                            <>
                                <div className='row mx-0 mb-3'>
                                    <div className='col-12'>

                                        <div className='mb-4'>
                                            <div className='mb-2'>
                                                <span className='font-w600'>
                                                    {`${adLinkObj?.title ? adLinkObj?.title?.toUpperCase() : ''}`}
                                                </span>
                                            </div>

                                            <div className='mb-2'>
                                                <span className="font-w600 text-black fs-1">
                                                    {`What’s been holding you back?`}
                                                </span>
                                            </div>

                                            <div className='mb-2'>
                                                <span className=' fs-5'>
                                                    {`We’ll start with what matters to you.`}
                                                </span>
                                            </div>
                                        </div>

                                        <div className='mb-5'>
                                            {adScreenTwoArr?.map((item, index) => {
                                                return (
                                                    <div
                                                        key={index}
                                                        className='mb-2 d-flex align-items-center justify-content-between cursor-pointer p-2 rounded-3 overlay-action-btn'
                                                        style={{
                                                            backgroundColor: adLinkSolutionObj?.id === item?.id ? 'rgb(255 165 0 / 18%)' : '',
                                                        }}
                                                        onClick={() => {
                                                            setAdSteps(3);
                                                            setAdLinkSolutionObj(item);
                                                        }}
                                                    >
                                                        <div className='me-2 d-flex justify-content-center align-items-center'>
                                                            <div className='me-3'>
                                                                <img src={item?.img} style={{ width: '50px', height: '50px' }} alt="" />
                                                            </div>
                                                            <div>
                                                                <span className=" text-black fs-4">
                                                                    {item?.title}
                                                                </span>
                                                            </div>
                                                        </div>

                                                        <div>
                                                            <i class="bi bi-chevron-right fs-3 text-black"></i>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>

                                        <div className='mb-2 d-flex align-items-center justify-content-center'>
                                            <span className='text-black d-flex align-items-center justify-content-center text-center fs-5'>
                                                {`Just show me how it works`}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </> :
                            adSteps === 3 ?
                                <>
                                    <div className='row mx-0 mb-3'>
                                        <div className='col-12'>

                                            <div className='mb-4'>
                                                <div className='mb-2 d-flex align-items-center justify-content-center'>
                                                    <span className="font-w600 text-black fs-1 text-center ">
                                                        {`Show Us What’s Broken. We Handle the Rest`}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className='mb-3'>
                                                <div
                                                    className='bg-black'
                                                    style={{
                                                        width: '100%',
                                                        height: '40dvh',
                                                        borderRadius: '15px'
                                                    }}
                                                >
                                                    <video
                                                        src={scanDeviceVid}
                                                        autoPlay
                                                        playsInline
                                                        width="100%"
                                                        height="100%"
                                                        loop
                                                        controls={false}
                                                        style={{
                                                            objectFit: "cover",
                                                            borderRadius: '15px',
                                                        }}
                                                        muted={true}></video>
                                                </div>
                                            </div>



                                            <div className='mb-2 d-flex align-items-center justify-content-center'>
                                                <span className='text-black d-flex align-items-center justify-content-center text-center fs-4'>
                                                    {`See how it works`}
                                                </span>
                                            </div>

                                            <div className='mb-3 d-flex align-items-center justify-content-center'>
                                                <span className='font-w600 text-black d-flex align-items-center justify-content-center text-center fs-2'>
                                                    {`Get Answers Fast and Free`}
                                                </span>
                                            </div>

                                            <div className='mb-3 d-flex align-items-center justify-content-center'>
                                                <PrimaryButton
                                                    buttonName={`Let’s take a look`}
                                                    style={{
                                                        width: "100%",
                                                        background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                        border: '2px solid rgba(255, 154, 32, 1)',
                                                        boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                        fontWeight: 600,
                                                    }}
                                                    onClick={() => {
                                                        navigate("/estimate");
                                                    }}
                                                    loadingMessage={"Sending code..."}
                                                    needIcon={true}
                                                    isLoading={false}
                                                    iconClassName="bi bi-arrow-right"
                                                />
                                            </div>

                                            <div className='mb-2 d-flex align-items-center justify-content-center'>
                                                <span className='d-flex align-items-center justify-content-center text-center'>
                                                    {`Free estimate. No account. No app.`}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </> : <></>
                    }


                </div>
                {window.innerWidth > 768 && <div className='col-md-3'></div>}
            </div>
        </>
    )
}

export default AdLinkA;